<template>
  <div @click="getStoryblokLink(content.link, content.target)" :class="getClass(content.type)" class="grid-item" v-editable="content">
    <div v-if="content.type !== 'bloc'" :style="`background-image:url(${content.img}/m/500x0)`" class="grid-bg"></div>

    <template v-if="content.text && content.text.length > 0">
      <div v-if="content.type === 'img'" class="z-10 absolute bottom-0 left-0 bg-blue-500 bg-opacity-75 py-2 px-4 flex justify-center gap-4">
        <h2 class="font-luckiest text-xl md:text-2xl text-white">{{content.text}}</h2>
        <fai class="icon text-white text-xl md:text-3xl" icon="chevron-right"></fai>
      </div>
      <div v-else-if="content.type === 'bloc'" class="absolute inset-0 py-2 px-3 md:py-4 md:px-6 d-flex flex-col md:flex-row gap-4 md:gap-6 items-start md:justify-between">
        <div class="d-flex flex-col gap-4">
          <div>
            <h2 class="font-luckiest text-xl md:text-3xl text-white">{{content.text}}</h2>
            <p class="font-bold text-white">{{content.title}}</p>
          </div>
          <fai class="icon text-white text-2xl md:text-5xl hidden md:block" icon="chevron-right"></fai>
        </div>
        <img class="h-8 w-auto md:w-20 md:h-auto" width="80" :src="content.img+'/m/160x0'" loading="lazy" alt="">
      </div>
      <div v-else class="grid-item-content"> <!-- legacy -->
        <fai class="icon" icon="angle-right"></fai>
        <div class="txt-content">
          <h2 class="title-font" v-html="content.text"></h2>
          <p>{{content.title}}</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import storyblokLink from "@/mixins/storyblokLink";
import imgOpti from "@/mixins/imgOpti.js";
export default {
  mixins: [storyblokLink, imgOpti],
  props: {
    content: {
      default: null,
      type: Object,
    },
    index: {
      default: 0,
      type: Number,
    },
  },
  data() {
    return {
      relWidth: null,
      img: "",
    };
  },
  mounted() {
    let e = document.getElementsByClassName("grid-bg");
    this.relWidth = Math.trunc(e[0].offsetWidth * 1.3);
    this.img = this.getBg(this.content.type, this.relWidth);
  },
  methods: {
    getClass(type) {
      switch (type) {
        case "img":
          return "grid-item-img";
          break;
        case "double":
          return "grid-item-double";
          break;
        case "bloc":
          return "grid-item-info";
          break;
        case "full":
          return "grid-item-full";
          break;
        case "half-left":
          return "grid-item-hl";
          break;
        case "half-left-empty":
          return "grid-item-hl-empty";
          break;
        case "half-right":
          return "grid-item-hr";
          break;
        case "half-right-empty":
          return "grid-item-hr-empty";
          break;
        default:
          return "grid-item-info";
          break;
      }
    },
    getWidth() {
      return window.innerWidth;
    },
    getBg(type, w) {
      if (type != "bloc") {
        return `url('${this.optimize(this.content.img, w)}')`;
      }
      return `url('${this.content.img}')`;
      /*if (this.content.type === "img" || this.content.type === "double") {
      } else {
        return {
          background: `linear-gradient(45deg, #3bb2c5 0%,#7db9e8 100%)`
        };
      }*/
    },
  },
};
</script>

<style lang="scss">
.grid-item {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  grid-column: span 2;

  &.grid-item-hl-empty,
  &.grid-item-hr-empty {
    pointer-events: none;
    .grid-bg {
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }
  }

  &.grid-item-img,
  &.grid-item-double,
  &.grid-item-full,
  &.grid-item-hr,
  &.grid-item-hl {
    .grid-bg {
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      transition: transform 0.4s;
      transform: scale(1);
    }

    &:hover {
      .grid-bg {
        transform: scale(1.15);
      }
    }
    .grid-item-content {
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.4);
      width: 70%;
      z-index: 1;
      padding: 20px;

      .icon {
        color: #fff;
        font-size: 40px;
      }
      p {
        color: #fff !important;
        text-transform: uppercase;
        font-weight: 200;
        font-size: 13px;
      }
      h2 {
        color: #fff;
        font-size: 20px;
        padding: 10px 0;
      }
    }
  }

  &.grid-item-info {
    grid-row: span 1;
    grid-column: span 1;
    background-color: $primary;
    justify-content: left;
    padding-left: 10%;
    .grid-bg {
      background-size: 95px;
      background-position: right 20% bottom 85%;
      background-repeat: no-repeat;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
    .grid-item-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      p {
        color: white;
        font-weight: 800;
        font-size: 18px;
      }
      h2 {
        color: #fff;
        font-size: 20px;
        padding-bottom: 3px;
        font-weight: normal;
      }
      .icon {
        color: #fff;
        margin-right: 10px;
        font-size: 60px;
        margin-right: 115px;
      }
    }
  }
  &.grid-item-double {
    grid-column: span 4;
  }
  &.grid-item-full {
    grid-column: span 6;
    .grid-item-content {
      display: flex;
      align-items: center;
      justify-content: center;
      left: inherit;
      top: inherit;
      bottom: inherit;
      width: auto;
      padding: 10px 40px;
      border-radius: 2px;
      max-width: 95%;
      margin: auto;
      position: absolute;
      bottom: 0;
      left: 0;
      p {
        color: white;
        font-weight: 800;
      }
      h2 {
        color: #fff;
      }
      .icon {
        color: #fff;
        margin-right: 10px;
        font-size: 70px;
      }
    }
  }
  &.grid-item-hl-empty,
  &.grid-item-hr-empty {
    grid-column: span 3;
  }
  &.grid-item-hl,
  &.grid-item-hr {
    grid-column: span 3;
    .grid-item-content {
      display: flex;
      align-items: center;
      justify-content: center;
      left: inherit;
      top: inherit;
      bottom: inherit;
      width: auto;
      padding: 10px 40px;
      border-radius: 2px;
      max-width: 95%;
      margin: auto;
      position: absolute;
      bottom: 0;
      left: 0;
      p {
        color: white;
        font-weight: 800;
      }
      h2 {
        color: #fff;
      }
      .icon {
        color: #fff;
        margin-right: 10px;
        font-size: 70px;
      }
    }
  }
}
@media screen and (max-width: $desktop) {
  .grid-item.grid-item-info {
    .grid-bg {
      background-size: 73px;
      background-position: right 20% bottom 85%;
    }
  }

  .grid-item.grid-item-full {
    grid-column: span 2;
  }
}

@media screen and (min-width: 981px) {
  .grid-item {
    grid-row: span 2;

    &.grid-item-info {
      grid-column: span 2;
    }
  }
}
</style>
